

import {
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";

import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import MainForm from "./shiftform"
import { PayrollClient } from "services";

const ShiftModalForm = ({ modal, toggle, addShiftData, reload, t, ...props }) => { 
    const payrollClient = PayrollClient();

    const [shifts, setShifts] = useState([]);
    var initial_state = {
        name: "",
        time_from: "",
        time_to: "",
        time_from2: null,
        time_to2: null,
        date_from: addShiftData.current.date_from ? addShiftData.current.date_from.toISOString().slice(0, 10) : '',
        date_to: addShiftData.current.date_to ? addShiftData.current.date_to.toISOString().slice(0, 10) : '',
        permanent:false,        
        userId: addShiftData.current.userId,
    }

    const [shiftForm, setShiftForm] = useState(initial_state)

    const [innerModal, setInnerModal] = useState(modal);


    const addItem = (validateForm, form_) => {

        const errors = validateForm(form_);

        if (errors.length > 0) {
            NotificationManager.error(errors[0]);
            return;
        }
        const shiftFormHolder = shiftForm // Object.entries(shiftForm).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {})

        payrollClient
            .post('shifts', {
                ...shiftFormHolder
            })
            .then(({ data }) => {
                setShifts([...shifts, data])
                NotificationManager.success(t("Saved successfully"));
                setShiftForm(initial_state)
                toggle()
                reload()
            })
            .catch((err) => {
                NotificationManager.error(t('Error while adding new shift'));
            });
    }

    useEffect(() => {
        setInnerModal(modal)
        setShiftForm(initial_state)
    }, [modal])

    return (
        <Modal isOpen={modal} toggle={toggle} >
            <ModalHeader toggle={toggle}>Add New Shift</ModalHeader>
            <ModalBody>
                <MainForm shiftForm={shiftForm} setShiftForm={setShiftForm} type="Add" action={addItem} t={t} />
            </ModalBody>
        </Modal>
    )
}

export default ShiftModalForm

